const namespace = 'app';

export const SET_BROWSER = `${namespace}/Browser Set`;
